import { render } from "./IconInvestedRounded.vue?vue&type=template&id=071d5206&ts=true"
import script from "./IconInvestedRounded.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRounded.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__